import { MenuBlock, MenuLeaf } from '../../../types/types';
import { normalizeSearchQuery } from './normalizeSearchQuery';

const matchesQuery = (label: string | undefined, query: string): boolean =>
  Boolean(label) && label!.toLowerCase().includes(query);

// Keeps a leaf when its own label matches; a submenu survives only when it still has matching records, even if its own label matches the query.
const filterLeaf = (item: MenuLeaf, query: string): MenuLeaf | null => {
  if (item.type === 'separator') {
    return null;
  }

  if (item.children) {
    const children = item.children
      .map((child) => filterLeaf(child, query))
      .filter((child): child is MenuLeaf => child !== null);

    if (children.length === 0) {
      return null;
    }

    return { ...item, children };
  }

  if (!matchesQuery(item.label, query)) {
    return null;
  }

  return item;
};

// Filters the side-menu tree to blocks/items whose label contains the query; blocks with no surviving children are dropped.
export const filterMenuItems = (
  menuItems: MenuBlock[],
  rawQuery: string
): MenuBlock[] => {
  const query = normalizeSearchQuery(rawQuery);
  if (!query) {
    return menuItems;
  }

  return menuItems
    .map((block) => {
      const children = (block.children ?? [])
        .map((item) => filterLeaf(item, query))
        .filter((item): item is MenuLeaf => item !== null);

      return { ...block, children };
    })
    .filter((block) => (block.children?.length ?? 0) > 0);
};
